module.exports = __webpack_public_path__ + "media/images/eraf_sunstar_en_2023-5eccded6cbcd657e4b55317ed99dd917.svg";